import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type HTMLAttributes } from 'vue';
import {
  SelectPortal,
  SelectContent,
  SelectViewport,
  SelectScrollUpButton,
  SelectScrollDownButton,
  useForwardPropsEmits,
  type SelectContentProps,
  type SelectContentEmits,
} from 'reka-ui';
import { ChevronDown, ChevronUp } from '@lucide/vue';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectContent',
  props: {
    forceMount: { type: Boolean },
    position: { default: 'popper' },
    bodyLock: { type: Boolean },
    memoDependencies: {},
    side: {},
    sideOffset: { default: 4 },
    sideFlip: { type: Boolean },
    align: {},
    alignOffset: {},
    alignFlip: { type: Boolean },
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    hideShiftedArrow: { type: Boolean },
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    dir: {},
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean },
    class: {}
  },
  emits: ["closeAutoFocus", "escapeKeyDown", "pointerDownOutside"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const forwarded = useForwardPropsEmits(
  computed(() => {
    const { class: _class, ...rest } = props;
    return rest;
  }),
  emit
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SelectPortal), null, {
    default: _withCtx(() => [
      _createVNode(_unref(SelectContent), _mergeProps(_unref(forwarded), {
        class: 
        _unref(cn)(
          'relative z-50 max-h-[var(--reka-select-content-available-height)] min-w-[var(--reka-select-trigger-width)] overflow-hidden rounded-lg border bg-popover text-popover-foreground shadow-[0_8px_24px_-8px_rgba(15,23,42,0.18)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0',
          props.class
        )
      
      }), {
        default: _withCtx(() => [
          _createVNode(_unref(SelectScrollUpButton), { class: "flex items-center justify-center py-1" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ChevronUp), { class: "size-4" })
            ]),
            _: 1
          }),
          _createVNode(_unref(SelectViewport), { class: "p-1" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }),
          _createVNode(_unref(SelectScrollDownButton), { class: "flex items-center justify-center py-1" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ChevronDown), { class: "size-4" })
            ]),
            _: 1
          })
        ]),
        _: 3
      }, 16, ["class"])
    ]),
    _: 3
  }))
}
}

})